import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState } from '../../../../store/root-reducer';
import OAuthAuthenticateCallback from './oauth-authenticate-callback';
import { oauthAuthenticateRequest } from '../oauth-buttons/extra-actions';
import { OAuthMethod } from '../oauth-buttons';
import { OAuthAuthenticateExtras } from '../../types';
import { getAgencyConfigRequest } from '../../../home/extra-actions';

const mapStateToProps = (state: RootState) => ({
  oauthAuthenticateRequestStatus: state.oauth.oauthAuthenticateRequest.status,
  oauthAuthenticateRequestMessage: state.oauth.oauthAuthenticateRequest.message,
  oauthAuthenticateRequestError: state.oauth.oauthAuthenticateRequest.error,

  token: state.oauth.token,
  trackingId: state.oauth.trackingId,
  firstName: state.oauth.firstName,
  lastName: state.oauth.lastName,
  email: state.oauth.email,
  action: state.oauth.action,
  agencyConfig: state.home.agencyConfig,

  getAgencyConfigRequestStatus: state.home.getAgencyConfigRequest.status,
});

const mapDispatchToProps = {
  sendOAuthAuthenticateRequest: (
    method: OAuthMethod,
    code: string,
    state?: string,
    extras?: OAuthAuthenticateExtras,
  ) => oauthAuthenticateRequest({ method, code, state, extras }),
  sendGetAgencyConfigRequest: (agencyConfigPayload: {
    baseUrl: string;
    email?: string;
  }) => getAgencyConfigRequest(agencyConfigPayload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> &
  RouteComponentProps<{ method: string }>;

export default connector(OAuthAuthenticateCallback);
